import { Checkbox } from "primereact/checkbox"

interface ICheck {
    name?: string,
    checked?: boolean,
    disabled?: boolean
}

export const JVCheck = (props: ICheck) => {
    return (
        <Checkbox disabled={props.disabled} name={props.name} checked={props.checked} />
    )
}